import {Col} from 'reactstrap'

export default function SideBar({children,xs,sm,md,lg,className}) {
   
  return (
    <>
      <Col xs={xs} sm={sm} md={md} lg={lg} className={className}>
          {children}       
      </Col>
    </>
  )
}
